import React from 'react';
import {isEmpty as _isEmpty} from 'lodash';

import {IconEdit, IconWithTooltip} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {WATERMARKING} from '@constants/resources';

import {EventWatermarkingCidrsCell} from './EventWatermarkingCidrsCell';
import {EventWatermarkingContentLabel} from './EventWatermarkingContentLabel';
import {
    getWatermarkingRowWarningText,
    hasNoWatermarkingCidrs,
    hasNoWatermarkingClients,
} from './eventWatermarkingTableHelper';

export const rowRenderer = (column, row, eventId) => {
    const iconWarningText = getWatermarkingRowWarningText(row);

    switch (column) {
        case 'content':
            return (
                <div className='eventWatermarking__contentCell'>
                    <EventWatermarkingContentLabel eventContent={row.event_content}/>
                </div>
            );
        case 'cidrs':
            return hasNoWatermarkingCidrs(row)
                ? 'All IPs'
                : <EventWatermarkingCidrsCell cidrs={row.cidrs}/>;
        case 'description':
            return row.description || '';
        case 'clients':
            return hasNoWatermarkingClients(row)
                ? 'All'
                : row.clients.map((client) => client.name).join(', ');
        case 'actions':
            return (
                <div className='actions-list-icon'>
                    <IconEdit
                        size='large'
                        resource={WATERMARKING}
                        link={getLink('events.watermarking.edit', {
                            id: eventId,
                            eventContentWatermarkId: row.id,
                        })}
                    />
                    {
                        (!_isEmpty(iconWarningText))
                            ? <IconWithTooltip
                                name='info circle'
                                iconProps={{size: 'large'}}
                                popupProps={{
                                    wide: 'very',
                                    position: 'top right',
                                }}
                                tooltip={iconWarningText}
                            />
                            : null
                    }
                </div>
            );
        default:
            return null;
    }
};
